import { Component, Input } from '@angular/core';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NgStyle, NgClass } from '@angular/common';

@Component({
  selector: 'app-user-avatar',
  standalone: true,
  imports: [NzAvatarModule, NgStyle, NgClass],
  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.scss'
})
export class UserAvatarComponent {
  @Input() public size: number;
  @Input() public initials: string;
  @Input() public profileColor: string;
  @Input() public avatarUrl: string;

  public get isAvatarExist(): boolean {
    return this.avatarUrl?.includes('.svg');
  }

  public get avatarSizeClass(): string {
    return this.size === 160 ? 'large-avatar' : 'default-avatar';
  }
}
